import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { AdminProfileState, ADMIN_PROFILE_SLICE_NAME, initialState } from './models';
import { changePassword, getAdminProfile, updateAdminProfile } from './actionCreators';
import { normalizeAdminProfileData } from '../helpers/normalizeAdminProfileData';

export const slice = createSlice({
  name: ADMIN_PROFILE_SLICE_NAME,
  initialState,
  reducers: {
    resetAdminProfileState() {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isFulfilled(getAdminProfile, updateAdminProfile), (state: AdminProfileState, action) => {
        const { payload } = action;
        state.profile = normalizeAdminProfileData(payload);
      })
      .addMatcher(isFulfilled(getAdminProfile, updateAdminProfile, changePassword), (state: AdminProfileState) => {
        state.isLoading = false;
      })
      .addMatcher(isPending(getAdminProfile), (state: AdminProfileState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(
        isRejected(getAdminProfile, updateAdminProfile, changePassword),
        (state: AdminProfileState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetAdminProfileState } = slice.actions;

export default slice.reducer;
